export const BACKEND_NAMESPACE = 'backend';
/**
 * Splits a `namespace:KEY` translation key. A key without a namespace comes from the backend and belongs to the
 * `backend` namespace.
 */
export function parseTranslationKey(fullKey) {
    const colonIndex = fullKey.indexOf(':');
    if (colonIndex === -1) {
        return { namespace: BACKEND_NAMESPACE, key: fullKey };
    }
    return {
        namespace: fullKey.substring(0, colonIndex),
        key: fullKey.substring(colonIndex + 1),
    };
}
